/* eslint-disable max-lines */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import axios from 'axios'
import styled from 'styled-components'
import constants from '../../constants/constants'
import styles from '../../constants/styles'
import colors from '../../constants/colors'
import { capitalizeString } from '../../lib/format'

const identities = [
  {
    type: 'omnivore',
    description: 'I consume both plant-based food and meat'
  },
  {
    type: 'flexitarian',
    description: `I consume plant-based food with the occasional inclusion of meat`
  },
  {
    type: 'pescatarian',
    description: `I consume seafood as the only type of meat in a vegetarian diet`
  },
  {
    type: 'vegetarian',
    description: `I don't consume meat, poultry or seafood`
  },
  {
    type: 'vegan, plant-based',
    description: `I don't consume anything that uses, exploits or is derived from animals`
  }
]

class LogIn extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      password: '',
      accessToken: '',
      username: '',
      identity: '',
      name: '',
      location: '',
      showPassword: false,
      focus: {
        email: false,
        password: false,
        username: false
      },
      errors: {
        email: '',
        password: '',
        username: '',
        identity: ''
      },
      loading: false,
      usernameChecked: 'idle'
    }
    this.handleChange = this.handleChange.bind(this)
    this.validateErrors = this.validateErrors.bind(this)
    this.checkForExistingEmail = this.checkForExistingEmail.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.checkUsername = this.checkUsername.bind(this)
  }

  handleChange(category, value) {
    const { errors } = this.state
    const obj = this.state
    obj[category] = value
    obj.errors = {
      ...errors
    }
    obj.errors[category] = ''
    this.setState(obj)
  }

  // TODO fix
  // eslint-disable-next-line sonarjs/cognitive-complexity,complexity
  validateErrors() {
    const { auth } = this.props
    const { email, password, username, identity, accessToken } = this.state

    const obj = this.state.errors
    let errors = false

    if (!auth.continueSignUp) {
      if (!email) {
        obj.email = 'Your email is required'
        errors = true
      }
      if (
        email &&
        !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          email
        )
      ) {
        obj.email = 'That email is invalid'
        errors = true
      }
      if (!password && !accessToken) {
        obj.password = 'Your password is required'
        errors = true
      }
      if (password.length < 8) {
        obj.password = 'Minimum 8 characters'
        errors = true
      }
      if (password.length > 99) {
        obj.password = 'Maximum 99 characters'
        errors = true
      }
      if (!auth.isLogIn) {
        if (!username) {
          obj.username = 'Please choose a username'
          errors = true
        }
        if (username && !/^[a-z0-9-]{1,20}$/.test(username)) {
          obj.username = 'Up to 20 lowercase letters and numbers only'
          errors = true
        }
      }
    } else if (!identity) {
      obj.identity = 'Please choose an identity'
      errors = true
    }

    this.setState({ errors: obj })
    return errors
  }

  checkForExistingEmail(isSignUp = false) {
    const { email, username, errors } = this.state

    this.setState({ loading: true })
    axios
      .get(`${constants.api.auth.check}email/${email}`)
      .then((res) => {
        this.setState({ loading: false })
        if (res.data) {
          const obj = {
            ...errors,
            email: 'This email address is already taken'
          }
          this.setState({ errors: obj })
        } else {
          window.scrollTo(0, 0)
          if (isSignUp) {
            this.checkUsername(username, true)
          } else {
            this.checkUsername(username)
          }
        }
      })
      .catch((err) => {
        this.setState({ loading: false })
        console.error(err)
        // TODO fix
        // eslint-disable-next-line no-alert
        window.alert(
          'There was a problem validating your email address. Please try again.'
        )
      })
  }

  // TODO fix
  // eslint-disable-next-line sonarjs/cognitive-complexity,complexity
  handleSubmit(e) {
    const { auth, isLogIn, handleLocalLogin } = this.props
    const { loading, section, username, usernameChecked, email, password } =
      this.state

    e.preventDefault()
    if (
      this.validateErrors() ||
      auth.authenticating ||
      loading ||
      (section === 0 && username.length > 0 && usernameChecked !== 'available')
    ) {
      return
    }

    if (!auth.continueSignUp) {
      if (isLogIn) {
        handleLocalLogin({
          email,
          password
        })
      } else {
        this.checkForExistingEmail()
      }
    } else {
      this.checkUsername(username, true)
    }
  }

  // TODO fix
  // eslint-disable-next-line sonarjs/cognitive-complexity
  checkUsername(username, isSignUp = false) {
    const { auth, handleSignUp, continueSignUp } = this.props
    const {
      email,
      password,
      // TODO fix
      // eslint-disable-next-line no-unused-vars
      accessToken,
      name,
      username: usernameState,
      identity,
      photo,
      errors
    } = this.state

    this.setState({ username: username.trim().toLowerCase() })
    if (!username) {
      return
    }
    this.setState({
      usernameChecked: 'checking',
      errors: { ...errors, username: '' }
    })
    axios
      .get(`${constants.api.auth.check}username/${username}`)
      // TODO fix
      // eslint-disable-next-line complexity
      .then((res) => {
        if (res.data) {
          this.setState({
            usernameChecked: 'taken',
            errors: {
              ...errors,
              username: 'That username is already taken'
            }
          })
        } else {
          this.setState({
            usernameChecked: 'available',
            errors: { ...errors, username: '' }
          })
          if (isSignUp) {
            if (this.validateErrors() || auth.authenticating) return
            const user = {}
            user.email = email
            user.password = password
            user.name =
              // TODO fix
              // eslint-disable-next-line no-nested-ternary
              name && name.length > 2
                ? name
                : usernameState.length > 2
                ? usernameState
                : 'name'
            user.username = usernameState
            user.identity = identity
            user.avatar = photo
            handleSignUp({ user })
          } else {
            continueSignUp()
          }
        }
      })
      .catch((err) => {
        console.error(err)
        this.setState({ loading: false })
      })
  }

  // TODO fix
  // eslint-disable-next-line sonarjs/cognitive-complexity,complexity
  render() {
    const { auth, isLogIn, handleAuthModal, signUpBack } = this.props
    const {
      focus,
      email,
      password,
      showPassword,
      username,
      usernameChecked,
      identity,
      errors,
      loading
    } = this.state
    return (
      <AuthFormContainer>
        {!auth.continueSignUp && (
          <Section>
            <CloseIcon
              className="fas fa-times"
              onClick={() => handleAuthModal(false)}
            />

            <Form onSubmit={this.handleSubmit}>
              <InputDiv>
                <InputName>Email</InputName>
                <InputContainer error={errors.email} hasFocus={focus.email}>
                  <InputText
                    type="email"
                    name="email"
                    value={email}
                    placeholder="Email Address"
                    onFocus={() =>
                      this.setState({
                        focus: { ...focus, email: true }
                      })
                    }
                    onBlur={() =>
                      this.setState({
                        focus: { ...focus, email: false }
                      })
                    }
                    onChange={(e) => this.handleChange('email', e.target.value)}
                  />
                </InputContainer>
                <ErrorDiv>{errors.email}</ErrorDiv>
              </InputDiv>

              <InputDiv>
                <InputName>Password</InputName>

                <InputContainer
                  error={errors.password}
                  hasFocus={focus.password}
                >
                  <InputText
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    value={password}
                    placeholder="Minimum 8 characters"
                    onFocus={() =>
                      this.setState({
                        focus: { ...focus, password: true }
                      })
                    }
                    onBlur={() =>
                      this.setState({
                        focus: { ...focus, password: false }
                      })
                    }
                    onChange={(e) =>
                      this.handleChange('password', e.target.value)
                    }
                  />
                  <ShowPassword
                    onClick={() =>
                      this.setState({ showPassword: !showPassword })
                    }
                  >
                    <i
                      className={
                        showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'
                      }
                      style={{
                        position: 'relative',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        paddingRight: styles.padding.medium,
                        color: colors.liquorice[100]
                      }}
                    />
                  </ShowPassword>
                </InputContainer>

                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <ErrorDiv>{errors.password}</ErrorDiv>
                </div>
              </InputDiv>

              {!isLogIn && (
                <InputDiv>
                  <InputName>Username</InputName>
                  <InputContainer
                    error={errors.username}
                    hasFocus={focus.username}
                  >
                    <InputText
                      type="text"
                      name="username"
                      placeholder="Lowercase letters and numbers only"
                      value={username}
                      onFocus={() =>
                        this.setState({
                          focus: { ...focus, username: true }
                        })
                      }
                      onBlur={() =>
                        this.setState({
                          focus: { ...focus, username: false }
                        })
                      }
                      onChange={(e) =>
                        this.handleChange('username', e.target.value)
                      }
                    />
                  </InputContainer>
                  <ErrorDiv>{errors.username}</ErrorDiv>
                </InputDiv>
              )}
              {isLogIn && (
                <ForgotPassword onClick={() => handleAuthModal(false)}>
                  <Link href="/auth/forgot" as="/forgot">
                    <a style={{ color: colors.liquorice[60] }}>
                      Forgot your password?
                    </a>
                  </Link>
                </ForgotPassword>
              )}
              <Submit onClick={this.handleSubmit}>
                {auth.authenticating ||
                loading ||
                (usernameChecked === 'checking' && username.length > 0) ? (
                  <i
                    className="fas fa-spinner fa-spin fa-2x fa-fw"
                    style={{
                      color: styles.colors.white
                    }}
                  />
                ) : (
                  <SubmitText>{isLogIn ? 'Log in' : 'Next (1/2)'}</SubmitText>
                )}
              </Submit>

              {auth.incorrectCredentials && (
                <ErrorDiv>Your email address or password is incorrect</ErrorDiv>
              )}
            </Form>

            <NoAccount>
              <div
                style={{
                  color: colors.liquorice[100],
                  paddingTop: styles.margin.large,
                  marginBottom: styles.margin.small
                }}
              >
                {isLogIn ? "Don't" : 'Already'} have an account?
              </div>
              <ModalSwitch
                onClick={() => {
                  this.setState({
                    errors: {
                      email: '',
                      password: '',
                      username: '',
                      identity: ''
                    }
                  })
                  handleAuthModal(true, !isLogIn)
                }}
              >
                <span
                  style={{
                    color: colors.palette.primary.main,
                    fontWeight: 700
                  }}
                >
                  {isLogIn ? 'Sign up' : 'Log in'}
                </span>
              </ModalSwitch>
            </NoAccount>
          </Section>
        )}

        {auth.continueSignUp && (
          <Section>
            <BackDiv>
              <Back onClick={signUpBack}>Back</Back>
            </BackDiv>
            <InputDiv>
              <InputName>I am a</InputName>
              {identities.map((i) => (
                <Identity
                  key={i.type}
                  active={identity === i.type}
                  identity={i.type}
                  error={errors.identity}
                  onClick={() =>
                    this.setState({
                      identity: i.type,
                      errors: { ...errors, identity: '' }
                    })
                  }
                >
                  <IdentityTitle>{capitalizeString(i.type)}</IdentityTitle>
                  <IdentityBody>{i.description}</IdentityBody>
                </Identity>
              ))}
              <ErrorDiv>{errors.identity}</ErrorDiv>
            </InputDiv>

            <Agree>
              By clicking Sign up, you acknowledge that you have read and agreed
              to our
              <a
                href="/policies/terms"
                target="_blank"
                rel="noopener noreferrer"
              ></a>
              .
            </Agree>

            <Submit onClick={this.handleSubmit}>
              {auth.authenticating ? (
                <i
                  className="fas fa-spinner fa-spin fa-2x fa-fw"
                  style={{
                    color: styles.colors.white
                  }}
                />
              ) : (
                <span
                  style={{
                    color: styles.colors.white
                  }}
                >
                  Sign up
                </span>
              )}
            </Submit>

            {auth.error && (
              <ErrorDiv>
                An unexpected error has occurred. Please try again.
              </ErrorDiv>
            )}
          </Section>
        )}
      </AuthFormContainer>
    )
  }
}

LogIn.propTypes = {
  auth: PropTypes.objectOf(PropTypes.any).isRequired,
  isLogIn: PropTypes.bool.isRequired,
  handleAuthModal: PropTypes.func.isRequired,
  handleLocalLogin: PropTypes.func.isRequired,
  continueSignUp: PropTypes.func.isRequired,
  signUpBack: PropTypes.func.isRequired,
  handleSignUp: PropTypes.func.isRequired
}

const AuthFormContainer = styled.main`
  width: 100%;
  height: 100%;
  background-color: ${styles.colors.white};
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: center;
  padding: ${styles.padding.large};
  overflow: auto;
  border-radius: 12px;
`

const CloseIcon = styled.span`
  font-size: 1.5em;
  cursor: pointer;
  color: ${colors.liquorice[100]};
  margin-bottom: ${styles.margin.medium};
`

const Section = styled.div`
  width: 100%;
  max-width: 480px;
  height: 100%;
`

const Form = styled.form`
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: center;
`

const InputDiv = styled.div`
  margin-bottom: ${styles.margin.small};
  width: 100%;
`

const InputName = styled.span`
  font-weight: 700;
  color: ${colors.liquorice[100]};
`

const InputContainer = styled.div`
  width: 100%;
  height: ${styles.height.small};
  display: flex;
  background-color: ${styles.colors.white};
  margin-top: ${styles.margin.small};
  border: 1px solid
    ${(props) =>
      // TODO fix
      // eslint-disable-next-line no-nested-ternary
      props.error
        ? styles.colors.action
        : props.hasFocus
        ? styles.colors.black
        : styles.colors.lightGrey};
  border-radius: ${styles.borderRadius.small};
`

const InputText = styled.input`
  width: 100%;
  height: 100%;
  background-color: transparent;
  font-size: 1em;
  padding: ${styles.padding.medium};
`

const ShowPassword = styled.span`
  text-align: right;
  float: right;
  cursor: pointer;
  color: ${colors.liquorice[100]};
  font-size: 0.8em;
`

const ErrorDiv = styled.span`
  color: ${styles.colors.action};
  margin-top: ${styles.margin.small};
  font-size: 0.8em;
`

const Submit = styled.div`
  width: 100%;
  max-width: 480px;
  height: ${styles.height.small};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.palette.primary.main};
  cursor: pointer;
  border-radius: ${styles.borderRadius.small};
  font-weight: 600;
  margin-top: 16px;
`

const SubmitText = styled.span`
  color: ${styles.colors.white};
  font-weight: 700;
`

const BackDiv = styled.div`
  margin-bottom: ${styles.margin.medium};
`
const Back = styled.a`
  padding: ${styles.padding.medium} ${styles.padding.small}
    ${styles.padding.medium} 0;
  color: ${colors.palette.tertiary.main};
`

const ForgotPassword = styled.div`
  width: 100%;
  max-width: 480px;
  color: ${colors.liquorice[100]};
  text-align: center;
  font-size: 0.9em;
`

const NoAccount = styled.div`
  width: 100%;
  max-width: 480px;
  font-size: 0.9em;
  margin: ${styles.margin.medium} 0;
  font-weight: 100;
  text-align: center;
`

const ModalSwitch = styled.span`
  color: ${styles.colors.brand};
  text-decoration: none;
  cursor: pointer;
  font-weight: 300;
`

const Identity = styled.div`
  width: 100%;
  overflow: hidden;
  border-radius: ${styles.borderRadius.small};
  color: ${(props) =>
    !props.active ? colors.liquorice[100] : styles.colors.white};
  background-color: ${(props) =>
    !props.active ? colors.palette.disabled : colors.palette.primary.main};

  cursor: pointer;
  margin-top: ${styles.margin.small};
`

const IdentityTitle = styled.div`
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
  margin: ${styles.padding.small} ${styles.padding.small} 0;
`
const IdentityBody = styled.div`
  font-size: 12px;
  line-height: 18px;
  margin: 0 ${styles.padding.small} ${styles.padding.small};
`
const Agree = styled(NoAccount)`
  font-size: 0.8em;
  font-weight: normal;
  color: ${styles.colors.darkGrey};
`

export default LogIn
